<router-outlet>
    <ng-snotify></ng-snotify>
    <app-spinner></app-spinner>
  </router-outlet>
  